import React from 'react';
import styles from './Button.module.scss';
import { Icon, IconName } from '../../../assets/icons';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Variante visual del botón */
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'cta' | 'create' | 'customize';
  /** Tamaño del botón */
  size?: 'sm' | 'md' | 'lg';
  /** Estado de carga */
  loading?: boolean;
  /** Icono a mostrar (opcional) */
  icon?: IconName;
  /** Posición del icono */
  iconPosition?: 'left' | 'right';
  /** Botón de ancho completo */
  fullWidth?: boolean;
  /** Solo icono (sin texto) */
  iconOnly?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  icon,
  iconPosition = 'left',
  fullWidth = false,
  iconOnly = false,
  disabled,
  className,
  ...props
}) => {
  const buttonClasses = [
    styles.button,
    styles[`button--${variant}`],
    styles[`button--${size}`],
    fullWidth && styles['button--full-width'],
    iconOnly && styles['button--icon-only'],
    loading && styles['button--loading'],
    className
  ].filter(Boolean).join(' ');

  const renderIcon = () => {
    if (loading) {
      return <div className={styles.spinner} />;
    }
    if (icon) {
      return (
        <Icon 
          name={icon} 
          className={styles.icon}
          width={getIconSize()}
          height={getIconSize()}
        />
      );
    }
    return null;
  };

  const getIconSize = () => {
    switch (size) {
      case 'sm': return 16;
      case 'lg': return 20;
      default: return 18;
    }
  };

  return (
    <button
      className={buttonClasses}
      disabled={disabled || loading}
      {...props}
    >
      {icon && iconPosition === 'left' && renderIcon()}
      {!iconOnly && children && <span className={styles.content}>{children}</span>}
      {icon && iconPosition === 'right' && renderIcon()}
      {iconOnly && renderIcon()}
    </button>
  );
};

export default Button; 